<div class="simple-card">
  <page-title></page-title>
</div>

<store-finder-form></store-finder-form>

<addresses-with-map></addresses-with-map>
